module.exports = __webpack_public_path__ + "static/media/capa-historia-1024.cbe00ddd.jpg";